var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"svg-icon",attrs:{"name":_vm.name}},[_c('use',{attrs:{"href":`#i-${_vm.name}`,"xlink:href":`#i-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }